export default "__VITE_ASSET__DCxe4E5O__"